import { Button, Form, Input, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
const BlogDetailForm = ({
  uploadProps,
  file,
  imgRequired,
  setPlaceholder,
  showPlaceholder,
}) => {
  return (
    <div className="py-5">
      <Form.Item
        name="image"
        label="Cover Photo"
        rules={[
          { required: imgRequired, message: "Please upload a Blog photo" },
        ]}
      >
        <Upload
          beforeUpload={() => false}
          listType="picture"
          {...uploadProps}
          fileList={file}
        >
          <Button icon={<UploadOutlined />}>Upload Image</Button>
        </Upload>
        {showPlaceholder && (
          <div>
            {" "}
            {/* OR */}
            <h4 className="placeholder-test">Or Select Placeholder</h4>
            {/* Upload Placeholder */}
            <div
              onClick={() => setPlaceholder(true)}
              className="button-placeholder"
            >
              Upload Placeholder Image
            </div>
          </div>
        )}
      </Form.Item>
      <Form.Item
        name="title"
        label="Title"
        rules={[{ required: true, message: "Title is required" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="shortDescription"
        label="Short Description"
        rules={[{ required: true, message: "Short description is required" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: false, message: "Description is required" }]}
      >
        <ReactQuill theme="snow" />
      </Form.Item>
    </div>
  );
};
export default BlogDetailForm;
